import React, { useContext, useEffect, useState } from "react";
import { Box, Grid } from "@mui/material";
import PageHeader from "../../../components/PageHeader";
import PackageTraking from "../../../components/PackageTraking";
import SidebarContext from "../../../context/SidebarContext";
import SimpleBar from "simplebar-react";
import AllUsers from "../Packages/AllUsers";
import PackagesUserwise from "../Packages/PackagesUserwise";
import AllAbandoned from "./AllAbandoned";
import AbandonedPackages from "./AbandonedPackages";
import { collection, onSnapshot, query, where } from "firebase/firestore";
import { db } from "../../../firebaseConfig";
import { useDispatch } from "react-redux";
import { setActiveItem } from "../../../store/commonSlice";

function Abandoned() {
  const dispatch = useDispatch();
  const { open } = useContext(SidebarContext);
  const [userActiveData, setUserActiveData] = useState({});
  const [packageActiveData, setPackageActiveData] = useState({});
  const [selectedFilters,setSelectedFilters]=useState({routePartnerId:"",warehouseId:""})
  const [filterOptions, setFilterOptions] = useState({
    routePartners: [],
    warehouses: [],
  });

  const [activeContent, setActiveContent] = useState({
    component: "Actions",
    data: undefined,
  });

  const userClickHandler = async (id, item) => {
    setActiveContent({ component: "Packages", data: id });
    setUserActiveData(item);
    dispatch(setActiveItem(null));
  };

  const packageClickHandler = async (id, item) => {
    setActiveContent({ component: "Actions", data: id });
    setPackageActiveData(item);
    dispatch(setActiveItem(null));
  };

  const changeFilterHandler = (filter) => {
    setSelectedFilters((prev) => ({ ...prev, ...filter }));
    if (filter?.routePartnerId) {
      const querySnapshot = collection(db, "routePartnerMainAddress");

      const q = query(
        querySnapshot,
        where("routePartnerId", "==", filter.routePartnerId)
      );
      onSnapshot(q, async (snapshot) => {
        const arr = [];
        snapshot.forEach((doc) => {
          arr.push({ ...doc.data(), id: doc.id });
        });
        setFilterOptions((prev) => ({ ...prev, warehouses: arr }));
      });
    }
  };

  useEffect(() => {
    // handler();
    try {
      const querySnapshot = collection(db, "routePartners");
      const q = query(querySnapshot, where("isDeleted", "==", false));
      onSnapshot(q, (snapshot) => {
        const arr = [];
        snapshot.forEach((doc) => {
          arr.push({ ...doc.data(), id: doc.id });
        });
        setFilterOptions({routePartners:arr,warehouses:[]});
      });
    } catch (err) {
      console.log(err, "err");
    }
  }, []);

  const steps = [
    {
      label: "Requested",
      date: packageActiveData?.packageShipmentCreationDate
        ? new Date(
            packageActiveData?.packageShipmentCreationDate?.seconds * 1000
          ).toLocaleDateString("en-US", {
            year: "numeric",
            month: "2-digit",
            day: "2-digit",
          })
        : "-",
    },
    {
      label: "Packing",
      date: packageActiveData?.preparedShipmentDate
        ? new Date(
            packageActiveData?.preparedShipmentDate?.seconds * 1000
          ).toLocaleDateString("en-US", {
            year: "numeric",
            month: "2-digit",
            day: "2-digit",
          })
        : "-",
    },
    {
      label: "Send",
      date: "-",
    },
    { label: "Done", date: "-" },
  ];

  const activeStep =
    packageActiveData?.packageStatus === "PREPARE_SHIPMENT_REQUEST_APPROVED" ? 2 : 1;

  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        height: "96vh",
        margin: "20px",
        marginRight: "0px",
        width: open === true ? "calc(98vw - 240px)" : "calc(98vw - 80px)",
        backgroundColor: "white",
        padding: "20px",
        borderRadius: "12px",
      }}
    >
      <PageHeader pageTitle={"Abandoned"} selectedFilters={selectedFilters} filterOptions={filterOptions} changeFilterHandler={changeFilterHandler}/>
      <Box
        sx={{
          flex: 1,
          backgroundColor: "white",
          borderTop: "1px solid #E5E5E8",
        }}
      >
        <Grid
          container
          spacing={0}
          sx={{
            width: open === false ? "calc(97vw - 80px)" : "calc(97vw - 240px)",
          }}
        >
          <Grid item xs={12} sm={12} md={3} lg={3}>
            <AllAbandoned
              userClickHandler={userClickHandler}
              userActiveData={userActiveData}
            />
          </Grid>
          <Grid
            item
            xs={12}
            sm={12}
            md={3}
            lg={3}
            sx={{ borderLeft: "1px solid #E5E5E8" }}
          >
            <AbandonedPackages
              packageClickHandler={packageClickHandler}
              userActiveData={userActiveData}
              packageActiveData={packageActiveData}
              selectedFilters={selectedFilters}
            />
          </Grid>
          <Grid
            item
            xs={12}
            sm={12}
            md={6}
            lg={6}
            sx={{
              borderLeft: "1px solid #E5E5E8",
              height: "86vh",
            }}
          >
            <SimpleBar
              forceVisible="y"
              autoHide={true}
              style={{ maxHeight: "86vh" }}
              className="custom-scrollbar"
            >
              <PackageTraking
                packageActiveData={packageActiveData}
                collection="shelfPackages"
                steps={steps}
                activeStep={activeStep}
                pageName="Abandoned"
              />
            </SimpleBar>
          </Grid>
        </Grid>
      </Box>
    </Box>
  );
}

export default Abandoned;
